
import { getPhoneRules } from "../../constants/Rules.js";
import { parsePhoneNumber } from "libphonenumber-js";

export default {
  computed: {
    phoneNumberRules() {
      return getPhoneRules(
        `${this.countryCode}${this.phoneNumber}`,
        this.getSelectedCountry()?.toUpperCase(),
        this.allowLandline
      );
    }
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        country_code: "+91",
        number: ""
      })
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    allowLandline: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: "Enter mobile number"
    },
    placeholder: {
      type: String,
      default: "Enter mobile number"
    }
  },
  data: () => ({
    countryCode: "+91",
    phoneNumber: "",
    valid: false
  }),
  beforeMount() {
    if (this.value?.country_code && this.value?.number) {
      this.countryCode = this.value.country_code;
      this.phoneNumber = this.value.number;
    }
  },
  mounted() {
    this.isValid();
  },
  methods: {
    handleNumberChange() {
      setTimeout(() => {
        this.isValid();
      });

      this.$emit("input", this.getParsedPhoneNumber());
    },
    getSelectedCountry() {
      const selectedCountry = this.$constants.Countries.COUNTRIES.find(
        (country) => country.phonecode === this.countryCode
      );
      return selectedCountry ? selectedCountry.iso : "default";
    },
    getParsedPhoneNumber() {
      const combinedPhoneNumber = `${this.countryCode}${this.phoneNumber}`;
      try {
        const parsedPhoneNumber = parsePhoneNumber(
          combinedPhoneNumber,
          this.getSelectedCountry()?.toUpperCase()
        );
        return {
          country_code: `+${parsedPhoneNumber.countryCallingCode}`,
          number: parsedPhoneNumber.nationalNumber
        };
      } catch (e) {
        return {
          country_code: this.countryCode,
          number: this.phoneNumber
        };
      }
    },
    isValid() {
      this.valid = this.$refs.textfield.validate();
      this.$emit("phoneNumberValidity", this.valid);
    }
  }
};
